import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CircleDotDashed, KeyRound, LayoutDashboard, Network, RadioTower, Server, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api';
import { InfoRow, PageHeader, StatCard, Surface } from '../../components/ui';

export default function OverviewPage() {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [connection, setConnection] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([api.getStats(), api.getDeviceServer()])
      .then(([statsData, connectionData]) => {
        setStats(statsData);
        setConnection(connectionData);
      })
      .catch((err) => setError(err.message));
  }, []);

  return (
    <div className="page">
      <PageHeader icon={LayoutDashboard} title={t('adminOverview.title')} subtitle={t('adminOverview.subtitle')} />
      {error && <div className="alert alert-danger" role="alert">{error}</div>}
      <div className="stat-grid">
        <StatCard icon={RadioTower} label={t('adminOverview.statTotal')} value={stats?.total} />
        <StatCard icon={ShieldCheck} label={t('adminOverview.statProvisioned')} value={stats?.provisioned} tone="success" sub="status: provisioned" />
        <StatCard icon={CircleDotDashed} label={t('adminOverview.statPending')} value={stats?.registered} tone="warning" sub="status: registered" />
      </div>

      <div className="content-grid">
        {connection && (
          <Surface className="grid-span-8" title={t('adminOverview.deviceServer')} icon={Network}>
            <div className="surface-body p-0">
              <InfoRow label={t('deviceDetail.fieldEndpoint')}><code>{connection.grpc_endpoint || '—'}</code></InfoRow>
              <InfoRow label={t('deviceDetail.fieldTransport')}><code>{connection.transport || '—'}</code></InfoRow>
            </div>
          </Surface>
        )}
        <Surface className={connection ? 'grid-span-4' : 'grid-span-12'} title={t('adminOverview.quickActions')} icon={Server}>
          <div className="surface-body d-grid gap-2">
            <Link to="/admin/devices" className="btn btn-outline-primary justify-content-start"><RadioTower className="icon" aria-hidden="true" />{t('adminOverview.actionManageDevices')}</Link>
            <Link to="/admin/tokens" className="btn btn-outline-secondary justify-content-start"><KeyRound className="icon" aria-hidden="true" />{t('adminOverview.actionCreateToken')}</Link>
          </div>
        </Surface>
      </div>
    </div>
  );
}
